import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="http://ryjfh.cn/ai/img_res/edited_4bf20b4eeb552a94a8465ff27976a85a_deb813b4.jpg"
        alt="韩漫网 - 韩漫免费阅读平台"
        title="韩漫免费阅读_韩漫在线_韩国漫画大全"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
            韩漫大全免费阅读平台
          </h1>
          <p className="mt-4 md:mt-6 text-sm md:text-base text-background-50/80 leading-relaxed max-w-2xl mx-auto">
            在这里，您可以免费阅读韩国漫画大全，在线浏览各种作品，享受便捷的阅读功能，轻松发现人气韩漫并随时沉浸于精彩剧情中。
          </p>
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/romance"
              className="px-8 py-3 text-sm font-semibold whitespace-nowrap rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 cursor-pointer"
            >
              开始阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 text-sm font-medium whitespace-nowrap rounded-md border border-background-50/30 text-background-50 hover:bg-background-50/10 transition-all duration-300 cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-8 md:mt-10 flex items-center justify-center gap-6 md:gap-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">50,000+</p>
              <p className="text-xs md:text-sm text-background-50/70 mt-1">漫画作品</p>
            </div>
            <div className="w-px h-8 md:h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">200万+</p>
              <p className="text-xs md:text-sm text-background-50/70 mt-1">日活用户</p>
            </div>
            <div className="w-px h-8 md:h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">500+</p>
              <p className="text-xs md:text-sm text-background-50/70 mt-1">每日更新</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="animate-bounce w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-2xl text-background-50/70"></i>
        </div>
      </div>
    </section>
  );
}